import { createSlice } from "@reduxjs/toolkit";

const initialEditItemModalState = { isOpen: false, details: { id: null, name: null, category: null, property_id: null, name_sq: null, name_de: null, name_en: null } }

const editItemModalSlice = createSlice({
    name: 'edit_item_modal',
    initialState: initialEditItemModalState,
    reducers: {
        openModal(state, action) {
            const {id, name, category, property_id, name_sq, name_de, name_en, onDelete} = action.payload.details
            state.isOpen = true
            state.details.id = id
            state.details.name = name
            state.details.category = category
            state.details.property_id = property_id
            // Delete reasons carry one name per language; the edit form prefills from these.
            state.details.name_sq = name_sq
            state.details.name_de = name_de
            state.details.name_en = name_en
        },
        closeModal(state) {
            state.isOpen = false
            state.details = { id: null, name: null, category: null, onDelete: null, property_id: null, name_sq: null, name_de: null, name_en: null }
        },
    }
})

export const editItemModalActions = editItemModalSlice.actions;
export default editItemModalSlice